// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__26efc"};